<template>
<div class="segment-detail-wrapper" ref="container">
  <div :class="['segment-detail-header', {'scroll' : isContainerScroll}]">
    <h6 class="title">
      {{ mineData.title || '[Scroll] 스크롤 데이터 분석 보고서'}}
    </h6>
    <button class="btn__close" @click="$emit('onCloseClick')">
      <i class="icon icon--close-btn"></i>
    </button>
    <span class="fade"></span>
  </div>

  <div class="segment-detail-body" ref="scroller">
    <template v-for="col in mineColumn">
      <div
        v-if="col.name !== 'text' || showMatchString"
        class="mine-info-column"
        :key="col.name"
        :class="[col.name , {active: isSegmentOn(col.name)}]">
        <div class="column-container">
          <div class="info-label">
            <span>{{ $t(`mine.report.detail.${col.name}`) }}</span>
          </div>
          <div class="info-value" :class="col.letterType">
            <template v-if="col.name === 'url'">
              <span class="">{{mineData.matchType ? `[${mineData.matchType}]` : '' }} {{ mineData.url }}</span>
            </template>
            <template v-else-if="col.name === 'text'">
              <span class="">{{ mineData.matchString }}</span>
            </template>
            <template v-else-if="col.name === 'period'">
              <div class="date-range base">{{ mineData.endDate ? `${mineData.startDate} ~ ${ mineData.endDate}`: mineData.startDate }} {{mineData.endTime ? mineData.endTime :''}}</div>
            </template>
            <template v-else-if="col.name === 'utm' || col.name === 'survey'">
              <div v-if="mineData.utm" class="marketing-info-btn">
                UTM Parameter
                <div class="marketing-info-column">
                  <div class="column-container marketing"
                       :key="key"
                       v-for="(values, key) in mineData.utm">
                    <div class="info-label">
                      <span>{{ key }}</span>
                    </div>
                    <div class="info-value">
                      <span>{{ formatValues(values) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="mineData.cid" class="marketing-info-btn">
                CID Parameter
                <div class="marketing-info-column">
                  <div class="column-container marketing"
                       :key="name"
                       v-for="(name, key) in cidLabels">
                    <template v-if="mineData.cid[key]">
                      <div class="info-label">
                        <span>{{ name }}</span>
                      </div>
                      <div class="info-value">
                        <span>{{ formatValues(mineData.cid[key]) }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div v-else class="colum-text">{{$t('common.all')}}</div>
            </template>
            <template v-else-if="col.name === 'existing'">
              {{ mineData[col.name] ? $t('common.revisit') : mineData[col.name] === false ? $t('common.new') : $t('common.all') }}
            </template>
            <template v-else-if="col.name === 'hour'">
              {{ mineData[col.name] && mineData[col.name] !== 'all' ? `${mineData[col.name]}:00 ~ ${mineData[col.name]}:59` : $t('common.all') }}
            </template>
            <template v-else-if="col.name === 'freq'">
              <span class="upper">
                {{ formatFreqRange(mineData[col.name], mineData['freq_option']) }}
              </span>
            </template>
            <template v-else>
              {{ mineData[col.name] && mineData[col.name] !== 'all' ? mineData[col.name] : $t('common.all') }}
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</div>
</template>
<script>
import { FREQUENCY_PV_RANGE, FREQUENCY_SESSION_RANGE, REPORT_MORE_DATA } from '@/libs/constants'

export default {
  name: 'MineSegmentDetail',
  props: {
    mineData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      mineColumn: [],
      isContainerScroll: false,
      resizeObserver: null
    }
  },
  created () {
    this.mineColumn = [...REPORT_MORE_DATA]
  },
  mounted () {
    const scroller = this.$refs.scroller
    if (!scroller) return

    // 1) 최초 상태 한번 계산
    this.handleScroll()

    // 2) 사이즈 변할 때도 다시 계산 (스크롤바 생겼는지/사라졌는지)
    this.resizeObserver = new ResizeObserver(() => {
      this.handleScroll()
    })
    this.resizeObserver.observe(scroller)

    // 3) 실제 스크롤할 때도 계산
    scroller.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  computed: {
    showMatchString () {
      return ['ends', 'contains', 'regexp'].includes(this.mineData.matchType)
    },
    cidLabels () {
      return {
        1: 'Site Code',
        2: 'Channel Category',
        3: 'Channel Type',
        4: 'Publisher',
        5: 'Product',
        6: 'Phase',
        7: 'Campaign Name',
        8: 'Content Type',
        9: 'Creative',
        10: 'Segmentation'
      }
    }
  },
  methods: {
    handleScroll () {
      const el = this.$refs.scroller
      const scrollTop = el.scrollTop
      const scrollHeight = el.scrollHeight
      const clientHeight = el.clientHeight
      const isScroll = scrollHeight > clientHeight // 스크롤바 생김
      const isTop = scrollTop <= 0 // 스크롤바 최상단 도달

      this.isContainerScroll = !isTop && isScroll
    },
    parseFreqArr (arr) {
      return arr.flatMap(item => {
        item = item.toString()
        const nums = item.replace(/[\[\]]/g, '')

        if (nums.includes('-')) {
          const [start, end] = nums.split('-').map(Number)
          return [start, end]
        }

        if (nums.includes('+')) {
          return -1
        }

        return [Number(nums)]
      })
    },
    formatFreqRange (arr, type) {
      if (!Array.isArray(arr) || arr.length === 0) {
        return this.$t('common.all')
      }

      const freqArr = arr

      const RANGE_MAP = type === 'session'
        ? FREQUENCY_SESSION_RANGE
        : FREQUENCY_PV_RANGE

      const DEFAULT_MAX = Math.max(...RANGE_MAP[1]) + 1

      const newNumber = freqArr.map(item => item === -1 ? DEFAULT_MAX : item)
      const min = Math.min(...newNumber)
      const max = Math.max(...newNumber)

      const ranges = Object.values(RANGE_MAP)
        .filter(value => {
          if (typeof value === 'number') {
            if (value === -1 && max === DEFAULT_MAX) {
              return value
            }
            return value >= min && value <= max
          }
          const [start, end] = value
          return start <= max && end >= min
        })
        .map(value => {
          if (typeof value === 'number') {
            if (value === -1) {
              return {
                start: type === 'session' ? 31 : 51,
                end: type === 'session' ? 31 : 51,
                text: type === 'session' ? `[${'31+'}]` : `[${'51+'}]`
              }
            }
            return { start: value, end: value, text: `[${value}]` }
          }
          const [start, end] = value
          return { start, end, text: `[${start}-${end}]` }
        })
        .sort((a, b) => a.start - b.start)

      return ranges.map(r => r.text).join(', ')
    },
    formatValues (arr) {
      return arr
        .map(v => v === '__null__'
          ? 'Inflow without utm_source parameter'
          : v
        )
        .join(', ')
    },
    isSegmentOn (key) {
      const segment = ['utm', 'ctaDom', 'refer', 'existing', 'hour', 'freq']
      const value = this.mineData[key]

      if (!segment.includes(key)) return false

      if (key === 'existing') {
        return typeof value === 'boolean' && value !== null
      }

      if (key === 'utm') {
        return (value && value !== 'all') || !!this.mineData.cid
      }

      // 다른 항목: 값이 존재하고 'all'이 아닐 때 true
      return value && value !== 'all'
    }
  }
}
</script>

<style scoped lang="scss">
.segment-detail {
  &-wrapper {
    max-width: 536px;
    min-height: 416px;
    max-height: 618px;
    width: 100%;
    overflow: hidden;
    background-color: #fff;
    border-radius: 14px;
    padding-bottom: 40px;
  }

  &-header {
    padding: 30px 28px 12px;
    position: relative;

    &.scroll {
      .fade {
        opacity: 1;
      }
    }

    .title {
      color: #2F2F2F;
      font-size: 15px;
      font-weight: 600;
      line-height: 150%;
    }

    .btn__close {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 14px;
      right: 14px;
    }

    .fade {
      transition: opacity 0.3s ease-in-out;
      opacity: 0;
      display: block;
      width: 100%;
      height: 30px;
      position: absolute;
      bottom: -29px;
      left: 50%;
      transform: translateX(-50%) rotate(180deg);
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 35.94%, rgba(255, 255, 255, 0.96) 61.46%, #FFF 100%);
      z-index: 1;
    }
  }

  &-body {
    padding: 24px 28px 0;
    max-height: 489px;
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 16px;
    }

    &::-webkit-scrollbar-thumb {
      outline: none;
      background-color: rgba(0, 0, 0, 0.30);
      border-radius: 50em;
      border: 4px solid #fff;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }

    .mine-info-column {
      display: flex;
      padding: 6px 0;
      gap: 12px;
      box-sizing: border-box;
      flex-direction: row;
      position: relative;
      flex-grow: 1;

      &.active {
        .column-container:not(.marketing){
          > .info-label {
            span {
              position: relative;
              color: #444;

              &:after {
                content: '';
                border-radius: 3px;
                background: #FFE2E7;
                position: absolute;
                width: 100%;
                padding: 0 4px;
                height: 20px;
                left: -4px;
                z-index: -1;
              }
            }
          }
        }
      }

      &.text {
        .column-container {
          >.info-label {
            span {
              color: #666;
              display: flex;
              align-items: center;
            }
          }

          >.info-value {
            span {
              color: #2f2f2f;
            }
          }
        }
      }

      &.column-container {
        & .target-column {
          position: absolute;
          display: flex;
          gap: 12px;
          top: 32px;
          width: 100%;

          & .info-label {
            width: 70px;
          }

          & .info-value {
            margin-left: 0;
          }
        }

        &.marketing {
          margin-top: 10px;

        }
      }

      &:last-child {
        border: 0;
      }

      &.period {
        .date-range {
          line-height: 1.5;
          + .date-range {
            margin-top: 4px;
          }
        }

        .date-compare-btn {
          cursor: pointer;
          display: flex;
          max-width: 171px;
          padding: 6px;
          justify-content: center;
          align-items: center;
          border-radius: 6px;
          border: 1px solid #C1C1C1;
          background-color: #fff;
          line-height: 1;

          color: #444;
          font-size: 13px;
          font-weight: 600;
        }
      }

      & .column-container {
        display: flex;
        gap: 40px;
        flex-grow: 1;
        align-items: flex-start;

        & > .info-label {
          width: 80px;
          flex-shrink: 0;
          vertical-align: middle;
          display: inline-block;
          span {
            color: #666;
            font-size: 14px;
            display: inline-block;
            font-weight: 400;
            line-height: 20px;
          }
        }

        & > .info-value {
          flex-grow: 1;
          color: #2F2F2F;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          &.upper {
            &:first-letter {
              text-transform: uppercase;
            }
          }
        }

        & > .search-exist {
          display: inline-block;
          &:first-letter {
            text-transform: uppercase;
          }
        }

        &.error {
          & .info-label {
            & > span {
              color: #cccccc;
            }
          }
        }
      }

      &:first-child {
        padding-top: 0;
      }
    }

    .marketing-info-column {
      margin-top: 10px;
      display: flex;
      flex-direction: column;

      .column-container {
        gap: 8px;
        > .info-label {
          min-width: 62px;
          flex-shrink: 0;
          span {
            color: #767676;
            font-size: 12px;
            line-height: 1;
          }
        }
        > .info-value {
          span {
            color: #666;
            font-size: 13px;
            line-height: 21px;
          }
        }
      }
    }
  }
}
</style>
